"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _withTheme = _interopRequireDefault(require("@material-ui/core/styles/withTheme"));
var _ = require("..");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTableEditCell extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "getStyle", () => {
      let cellStyle = {
        boxShadow: "2px 0px 15px rgba(125,147,178,.25)",
        color: "inherit",
        width: this.props.columnDef.tableData.width,
        boxSizing: "border-box",
        fontSize: "inherit",
        fontFamily: "inherit",
        fontWeight: "inherit",
        padding: "0 16px"
      };
      if (typeof this.props.columnDef.cellStyle === "function") {
        cellStyle = (0, _objectSpread2.default)({}, cellStyle, this.props.columnDef.cellStyle(this.state.value, this.props.rowData));
      } else {
        cellStyle = (0, _objectSpread2.default)({}, cellStyle, this.props.columnDef.cellStyle);
      }
      if (typeof this.props.cellEditable.cellStyle === "function") {
        cellStyle = (0, _objectSpread2.default)({}, cellStyle, this.props.cellEditable.cellStyle(this.state.value, this.props.rowData, this.props.columnDef));
      } else {
        cellStyle = (0, _objectSpread2.default)({}, cellStyle, this.props.cellEditable.cellStyle);
      }
      return cellStyle;
    });
    (0, _defineProperty2.default)(this, "handleKeyDown", e => {
      if (e.keyCode === 13) {
        this.onApprove();
      } else if (e.keyCode === 27) {
        this.onCancel();
      }
    });
    (0, _defineProperty2.default)(this, "onApprove", () => {
      this.setState({
        isLoading: true
      }, () => {
        this.props.cellEditable.onCellEditApproved(this.state.value,
        // newValue
        this.props.rowData[this.props.columnDef.field],
        // oldValue
        this.props.rowData,
        // rowData with old value
        this.props.columnDef // columnDef
        ).then(() => {
          this.setState({
            isLoading: false
          });
          this.props.onCellEditFinished(this.props.rowData, this.props.columnDef);
        }).catch(error => {
          this.setState({
            isLoading: false
          });
        });
      });
    });
    (0, _defineProperty2.default)(this, "onCancel", () => {
      this.props.onCellEditFinished(this.props.rowData, this.props.columnDef);
    });
    this.state = {
      isLoading: false,
      value: this.props.rowData[this.props.columnDef.field]
    };
  }
  renderActions() {
    if (this.state.isLoading) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          width: 60
        }
      }, /*#__PURE__*/React.createElement(_CircularProgress.default, {
        size: 20
      }));
    }
    const actions = [{
      icon: this.props.icons.Check,
      tooltip: this.props.localization.saveTooltip,
      onClick: this.onApprove,
      disabled: this.state.isLoading
    }, {
      icon: this.props.icons.Clear,
      tooltip: this.props.localization.cancelTooltip,
      onClick: this.onCancel,
      disabled: this.state.isLoading
    }];
    return /*#__PURE__*/React.createElement(this.props.components.Actions, {
      actions: actions,
      components: this.props.components,
      size: "small"
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(_TableCell.default, {
      size: this.props.size,
      style: this.getStyle(),
      padding: "none"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        marginRight: 4
      }
    }, /*#__PURE__*/React.createElement(this.props.components.EditField, {
      columnDef: this.props.columnDef,
      value: this.state.value,
      onChange: value => this.setState({
        value
      }),
      onKeyDown: this.handleKeyDown,
      disabled: this.state.isLoading,
      autoFocus: true
    })), this.renderActions()));
  }
}
MTableEditCell.defaultProps = {
  columnDef: {}
};
MTableEditCell.propTypes = {
  cellEditable: _propTypes.default.object.isRequired,
  columnDef: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  errorState: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
  icons: _propTypes.default.object.isRequired,
  localization: _propTypes.default.object.isRequired,
  onCellEditFinished: _propTypes.default.func.isRequired,
  rowData: _propTypes.default.object.isRequired,
  size: _propTypes.default.string
};
var _default = exports.default = (0, _withTheme.default)(MTableEditCell);